import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/helpers/auth.guard';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () =>
      import('./layout/layout.module').then((m) => m.LayoutPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'reportDesigner',
    loadChildren: () =>
      import('./pages/report-designer/report-designer.module').then(
        (m) => m.ReportDesignerPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then(
        (m) => m.DashboardPageModule
      ),
  },
  {
    path: 'customers',
    loadChildren: () =>
      import('./pages/definations/customers/customers.module').then(
        (m) => m.CustomersPageModule
      ),
  },
  {
    path: 'view-customer',
    loadChildren: () =>
      import(
        './pages/definations/customers/view-customer/view-customer.module'
      ).then((m) => m.ViewCustomerPageModule),
  },
  {
    path: 'customer-form',
    loadChildren: () =>
      import(
        './pages/definations/customers/customer-form/customer-form.module'
      ).then((m) => m.CustomerFormPageModule),
  },
  {
    path: 'products',
    loadChildren: () =>
      import('./pages/definations/products/products.module').then(
        (m) => m.ProductsPageModule
      ),
  },
  {
    path: 'definations',
    loadChildren: () =>
      import('./pages/definations/definations.module').then(
        (m) => m.DefinationsPageModule
      ),
  },
  {
    path: 'user-management',
    loadChildren: () =>
      import('./pages/definations/user-management/user-management.module').then(
        (m) => m.UserManagementPageModule
      ),
  },
  {
    path: 'user-management-form',
    loadChildren: () =>
      import(
        './pages/definations/user-management/user-management-form/user-management-form.module'
      ).then((m) => m.UserManagementFormPageModule),
  },
  {
    path: 'dashboard-form',
    loadChildren: () =>
      import('./pages/dashboard/dashboard-form/dashboard-form.module').then(
        (m) => m.DashboardFormPageModule
      ),
  },
  {
    path: 'modal-preview-image',
    loadChildren: () =>
      import('./pages/modal-preview-image/modal-preview-image.module').then(
        (m) => m.ModalPreviewImagePageModule
      ),
  },
  {
    path: 'user-detail',
    loadChildren: () =>
      import('./pages/definations/user-detail/user-detail.module').then(
        (m) => m.UserDetailPageModule
      ),
  },
  {
    path: 'user-detail-form',
    loadChildren: () =>
      import(
        './pages/definations/user-detail/user-detail-form/user-detail-form.module'
      ).then((m) => m.UserDetailFormPageModule),
  },
  {
    path: 'reportList',
    loadChildren: () =>
      import('./pages/report-list/report-list.module').then(
        (m) => m.ReportListPageModule
      ),
  },
  {
    path: 'report-api',
    loadChildren: () =>
      import('./pages/report-designer/report-api/report-api.module').then(
        (m) => m.ReportApiPageModule
      ),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./pages/profile/profile.module').then((m) => m.ProfilePageModule),
  },
  {
    path: 'app-configs',
    loadChildren: () =>
      import('./pages/definations/app-configs/app-configs.module').then(
        (m) => m.AppConfigsPageModule
      ),
  },
  {
    path: 'app-configs-form',
    loadChildren: () =>
      import(
        './pages/definations/app-configs/app-configs-form/app-configs-form.module'
      ).then((m) => m.AppConfigsFormPageModule),
  },
  {
    path: 'data-source',
    loadChildren: () =>
      import('./pages/definations/data-source/data-source.module').then(
        (m) => m.DataSourcePageModule
      ),
  },
  {
    path: 'data-source-form',
    loadChildren: () =>
      import(
        './pages/definations/data-source/data-source-form/data-source-form.module'
      ).then((m) => m.DataSourceFormPageModule),
  },
  {
    path: 'data-store',
    loadChildren: () =>
      import('./pages/definations/data-store/data-store.module').then(
        (m) => m.DataStorePageModule
      ),
  },
  {
    path: 'data-store-form',
    loadChildren: () =>
      import(
        './pages/definations/data-store/data-store-form/data-store-form.module'
      ).then((m) => m.DataStoreFormPageModule),
  },
  {
    path: 'selection-modal',
    loadChildren: () =>
      import('./pages/selection-modal/selection-modal.module').then(
        (m) => m.SelectionModalPageModule
      ),
  },
  {
    path: 'query',
    loadChildren: () =>
      import('./pages/definations/query/query.module').then(
        (m) => m.QueryPageModule
      ),
  },
  {
    path: 'query-form',
    loadChildren: () =>
      import('./pages/definations/query/query-form/query-form.module').then(
        (m) => m.QueryFormPageModule
      ),
  },
  {
    path: 'query-result-cache',
    loadChildren: () =>
      import(
        './pages/definations/query-result-cache/query-result-cache.module'
      ).then((m) => m.QueryResultCachePageModule),
  },
  {
    path: 'query-result-cache-form',
    loadChildren: () =>
      import(
        './pages/definations/query-result-cache/query-result-cache-form/query-result-cache-form.module'
      ).then((m) => m.QueryResultCacheFormPageModule),
  },
  {
    path: 'workbooks-menu',
    loadChildren: () =>
      import('./pages/workbooks-menu/workbooks-menu.module').then(
        (m) => m.WorkbooksMenuPageModule
      ),
  },
  {
    path: 'data-sources-menu',
    loadChildren: () =>
      import('./pages/data-sources-menu/data-sources-menu.module').then(
        (m) => m.DataSourcesMenuPageModule
      ),
  },
  {
    path: 'data-store-menu',
    loadChildren: () =>
      import('./pages/data-store-menu/data-store-menu.module').then(
        (m) => m.DataStoreMenuPageModule
      ),
  },
  {
    path: 'data-sources-menu-form',
    loadChildren: () =>
      import(
        './pages/data-sources-menu/data-sources-menu-form/data-sources-menu-form.module'
      ).then((m) => m.DataSourcesMenuFormPageModule),
  },
  {
    path: 'data-sources-schema',
    loadChildren: () =>
      import(
        './pages/data-sources-menu/data-sources-schema/data-sources-schema.module'
      ).then((m) => m.DataSourcesSchemaPageModule),
  },
  {
    path: 'data-sources-schema-details',
    loadChildren: () =>
      import(
        './pages/data-sources-menu/data-sources-schema/data-sources-schema-details/data-sources-schema-details.module'
      ).then((m) => m.DataSourcesSchemaDetailsPageModule),
  },
  {
    path: 'workbooks-menu-form',
    loadChildren: () =>
      import(
        './pages/workbooks-menu/workbooks-menu-form/workbooks-menu-form.module'
      ).then((m) => m.WorkbooksMenuFormPageModule),
  },
  {
    path: 'workbooks-menu-chat-modal',
    loadChildren: () =>
      import(
        './pages/workbooks-menu/workbooks-menu-chat-modal/workbooks-menu-chat-modal.module'
      ).then((m) => m.WorkbooksMenuChatModalPageModule),
  },
  {
    path: 'json-viewer',
    loadChildren: () =>
      import('./pages/json-viewer/json-viewer.module').then(
        (m) => m.JsonViewerPageModule
      ),
  },
  {
    path: 'notifications',
    loadChildren: () =>
      import('./pages/notifications/notifications.module').then(
        (m) => m.NotificationsPageModule
      ),
  },
  {
    path: 'permission',
    loadChildren: () =>
      import('./pages/definations/permission/permission.module').then(
        (m) => m.PermissionPageModule
      ),
  },
  {
    path: 'permission-form',
    loadChildren: () =>
      import(
        './pages/definations/permission/permission-form/permission-form.module'
      ).then((m) => m.PermissionFormPageModule),
  },
  {
    path: 'permission-control-form',
    loadChildren: () =>
      import(
        './pages/permission-control-form/permission-control-form.module'
      ).then((m) => m.PermissionControlFormPageModule),
  },
  {
    path: 'data-source-type-selection-modal',
    loadChildren: () =>
      import(
        './pages/data-sources-menu/data-source-type-selection-modal/data-source-type-selection-modal.module'
      ).then((m) => m.DataSourceTypeSelectionModalPageModule),
  },
  {
    path: 'forget-password',
    loadChildren: () =>
      import('./pages/forget-password/forget-password.module').then(
        (m) => m.ForgetPasswordPageModule
      ),
  },
  {
    path: 'dev-extreme',
    loadChildren: () =>
      import('./pages/example/dev-extreme/dev-extreme.module').then(
        (m) => m.DevExtremePageModule
      ),
  },
  {
    path: 'report-export-ai/:id',
    loadChildren: () =>
      import(
        './pages/report-list/report-export-ai/report-export-ai.module'
      ).then((m) => m.ReportExportAiPageModule),
  },
  {
    path: 'report-export-ai',
    loadChildren: () =>
      import(
        './pages/report-list/report-export-ai/report-export-ai.module'
      ).then((m) => m.ReportExportAiPageModule),
  },
  {
    path: 'report-export-history',
    loadChildren: () =>
      import('./pages/report-export-history/report-export-history.module').then(
        (m) => m.ReportExportHistoryPageModule
      ),
  },
  {
    path: 'dashboard-grid',
    loadChildren: () =>
      import('./pages/dashboard-grid/dashboard-grid.module').then(
        (m) => m.DashboardGridPageModule
      ),
  },
  {
    path: 'user-management-grid',
    loadChildren: () =>
      import(
        './pages/definations/user-management-grid/user-management-grid.module'
      ).then((m) => m.UserManagementGridPageModule),
  },
  {
    path: 'user-detail-grid',
    loadChildren: () =>
      import(
        './pages/definations/user-detail-grid/user-detail-grid.module'
      ).then((m) => m.UserDetailGridPageModule),
  },
  {
    path: 'user-detail-grid-form',
    loadChildren: () =>
      import(
        './pages/definations/user-detail-grid/user-detail-grid-form/user-detail-grid-form.module'
      ).then((m) => m.UserDetailGridFormPageModule),
  },
  {
    path: 'workbooks-menu-form-grid',
    loadChildren: () =>
      import(
        './pages/workbooks-menu/workbooks-menu-form-grid/workbooks-menu-form-grid.module'
      ).then((m) => m.WorkbooksMenuFormGridPageModule),
  },
  {
    path: 'dashboard-grid-form',
    loadChildren: () =>
      import(
        './pages/dashboard-grid/dashboard-grid-form/dashboard-grid-form.module'
      ).then((m) => m.DashboardGridFormPageModule),
  },
  {
    path: 'data-sources-grid-menu-form',
    loadChildren: () =>
      import(
        './pages/data-sources-menu/data-sources-grid-menu-form/data-sources-grid-menu-form.module'
      ).then((m) => m.DataSourcesGridMenuFormPageModule),
  },
  {
    path: 'layout-definations',
    loadChildren: () =>
      import(
        './pages/definations/layout-definations/layout-definations.module'
      ).then((m) => m.LayoutDefinationsPageModule),
  },
  {
    path: 'layout-definations-form',
    loadChildren: () =>
      import(
        './pages/definations/layout-definations/layout-definations-form/layout-definations-form.module'
      ).then((m) => m.LayoutDefinationsFormPageModule),
  },
  {
    path: 'dashboard-panel',
    loadChildren: () =>
      import('./pages/definations/dashboard-panel/dashboard-panel.module').then(
        (m) => m.DashboardPanelPageModule
      ),
  },
  {
    path: 'dashboard-panel-form',
    loadChildren: () =>
      import(
        './pages/definations/dashboard-panel/dashboard-panel-form/dashboard-panel-form.module'
      ).then((m) => m.DashboardPanelFormPageModule),
  },
  {
    path: 'data-store-type-selection-modal',
    loadChildren: () =>
      import(
        './pages/data-store-menu/data-store-type-selection-modal/data-store-type-selection-modal.module'
      ).then((m) => m.DataStoreTypeSelectionModalPageModule),
  },
  {
    path: 'dashboard-panel-menu',
    loadChildren: () =>
      import('./pages/dashboard-panel-menu/dashboard-panel-menu.module').then(
        (m) => m.DashboardPanelMenuPageModule
      ),
  },
  {
    path: 'dashboard-panel-chat-bot',
    loadChildren: () =>
      import(
        './pages/dashboard-panel-menu/dashboard-panel-chat-bot/dashboard-panel-chat-bot.module'
      ).then((m) => m.DashboardPanelChatBotPageModule),
  },
  {
    path: 'user-management-grid-form',
    loadChildren: () =>
      import(
        './pages/definations/user-management-grid/user-management-grid-form/user-management-grid-form.module'
      ).then((m) => m.UserManagementGridFormPageModule),
  },
  {
    path: 'change-password-modal',
    loadChildren: () =>
      import('./pages/change-password-modal/change-password-modal.module').then(
        (m) => m.ChangePasswordModalPageModule
      ),
  },
  {
    path: 'report-grid',
    loadChildren: () =>
      import('./pages/definations/report-grid/report-grid.module').then(
        (m) => m.ReportGridPageModule
      ),
  },
  {
    path: 'report-export-grid',
    loadChildren: () =>
      import(
        './pages/definations/report-export-grid/report-export-grid.module'
      ).then((m) => m.ReportExportGridPageModule),
  },
  {
    path: 'report-group-grid',
    loadChildren: () =>
      import(
        './pages/definations/report-group-grid/report-group-grid.module'
      ).then((m) => m.ReportGroupGridPageModule),
  },
  {
    path: 'dx-dashboard-demo',
    loadChildren: () =>
      import('./dx-dashboard-demo/dx-dashboard-demo.module').then(
        (m) => m.DxDashboardDemoPageModule
      ),
  },
  {
    path: 'dashboard-definitions',
    loadChildren: () => import('./pages/dashboard-definitions/dashboard-definitions.module').then( m => m.DashboardDefinitionsPageModule)
  },
  {
    path: 'empty-dashboard',
    loadChildren: () => import('./pages/empty-dashboard/empty-dashboard.module').then( m => m.EmptyDashboardPageModule)
  },
  {
    path: 'report-gallery',
    loadChildren: () =>
      import('./pages/report-gallery/report-gallery.module').then(
        (m) => m.ReportGalleryPageModule
      ),
  },
  {
    path: 'user-and-user-details-management',
    loadChildren: () => import('./pages/definations/user-and-user-details-management/user-and-user-details-management.module').then( m => m.UserAndUserDetailsManagementPageModule)
  },
  {
    path: 'user-and-user-details-management-form',
    loadChildren: () => import('./pages/definations/user-and-user-details-management/user-and-user-details-management-form/user-and-user-details-management-form.module').then( m => m.UserAndUserDetailsManagementFormPageModule)
  },
  {
    path: 'ai-call-analysis',
    loadChildren: () =>
      import('./pages/ai-call-analysis/ai-call-analysis.module').then(
        (m) => m.AiCallAnalysisPageModule
      ),
  },
  {
    path: 'document-management',
    loadChildren: () =>
      import('./pages/document-management/document-management.module').then(
        (m) => m.DocumentManagementPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'knowledge-base',
    loadChildren: () =>
      import('./pages/knowledge-base/knowledge-base.module').then(
        (m) => m.KnowledgeBasePageModule
      ),
    canActivate: [AuthGuard],
  },



































  
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
